export enum SimulationVisibility {
  Private = 'Private',
  Colleagues = 'Colleagues',
  Public = 'Public'
}
